"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[37070],{

/***/ 409122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useFilter; }
/* harmony export */ });
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(420577);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(446586);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(933756);
/* harmony import */ var hooks_useSearchAlgo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(228576);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(634655);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var _shared_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(774608);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};








const useFilter = (newQuery, setNewQuery, options)=>{
    const { defaultSortOptionCode , sortByCreatedAt  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const { query  } = router;
    const { trackingScreenName  } = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useScreen */ .EV)();
    const { noActiveDefaultSortOption  } = (0,hooks_useSearchAlgo__WEBPACK_IMPORTED_MODULE_5__/* .useSearchAlgo */ .t)();
    const rootPath =  true ? window.location.pathname : 0;
    const clearFilterLink = rootPath === "/search" ? "/search?router=productListing".concat(query.query ? "&query=".concat(query.query) : "") : "".concat( true ? window.location.origin : 0).concat(rootPath);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        setNewQuery(query);
    }, [
        JSON.stringify(query)
    ]);
    const getActiveFilterOptions = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((filterOptions)=>{
        const activatedFilters = [];
        const optionDictionary = filterOptions.reduce((acc, cur)=>{
            return [
                ...acc,
                ...cur.options
            ];
        }, []).reduce((acc, cur)=>{
            const optionCode = cur.optionId;
            return _objectSpreadProps(_objectSpread({}, acc), {
                [optionCode]: cur
            });
        }, {});
        Object.keys(newQuery).forEach((key)=>{
            try {
                const values = newQuery[key];
                const filterValues = typeof values == "string" ? values.split(",") : values;
                filterValues.forEach((value)=>{
                    if (optionDictionary[value] && key === optionDictionary[value].filterCode) {
                        activatedFilters.push(optionDictionary[value]);
                    }
                });
            } catch (err) {
                _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error(err);
                _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error("Problematic query key: ".concat(key, " value: ").concat(newQuery[key]));
            }
        });
        return activatedFilters.map((filter)=>_objectSpread({}, filter));
    }, [
        newQuery
    ]);
    const changeRouteQuery = (routeQuery)=>{
        router.push({
            pathname: router.pathname,
            query: routeQuery
        }, {
            pathname: rootPath,
            query: (0,_shared_helpers__WEBPACK_IMPORTED_MODULE_6__/* .omitQuery */ .pt)(routeQuery)
        }, {
            shallow: true
        });
    };
    const modifyBehaviorBaseOnOptions = (routeQuery, overrideOptions)=>{
        const { autoSubmit  } = _objectSpread({}, options, overrideOptions);
        const { page  } = routeQuery, restQuery = _objectWithoutProperties(routeQuery, [
            "page"
        ]);
        setNewQuery(restQuery);
        if (autoSubmit) {
            changeRouteQuery(routeQuery);
            const { price_gte , price_lte  } = routeQuery;
            const targetUrl = new URL(window.location.origin);
            targetUrl.pathname = rootPath;
            targetUrl.search = new URLSearchParams(routeQuery).toString();
            (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_7__/* .trackManually */ .gu)("applyFilter", "sortFilterProduct", trackingScreenName, JSON.stringify(_objectSpreadProps(_objectSpread({
                screenName: trackingScreenName
            }, price_gte ? {
                validatedPriceGte: price_gte
            } : {}, price_lte ? {
                validatedPriceLte: price_lte
            } : {}), {
                url: targetUrl.toString()
            })));
        }
    };
    const onClickFilterOption = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((value, options)=>{
        const { page  } = newQuery, filterParams = _objectWithoutProperties(newQuery, [
            "page"
        ]);
        let routeQuery = {};
        const targetUrl = new URL(window.location.origin);
        targetUrl.pathname = rootPath;
        const trackingData = {
            contentName: "",
            regionName: "sortFilterProduct",
            target: trackingScreenName || "",
            payload: {}
        };
        if (value.filterCode === "price") {
            const { ["price_gte"]: tbr , ["price_lte"]: tbr2  } = filterParams, restFilterParams = _objectWithoutProperties(filterParams, [
                "price_gte",
                "price_lte"
            ]);
            routeQuery = restFilterParams;
        } else if (value.filterCode != undefined && filterParams[value.filterCode]) {
            var ref;
            // if filterCode existed
            const filterCodeValues = ((ref = filterParams[value.filterCode]) === null || ref === void 0 ? void 0 : ref.toString().split(",")) || [];
            const index = value.optionId !== null ? filterCodeValues.indexOf(value.optionId.toString()) : -1;
            // if this option is selected before
            if (index !== -1) {
                filterCodeValues.splice(index, 1);
            } else {
                // else if we are select a new option
                value.optionId !== null && filterCodeValues.push(value.optionId.toString());
                trackingData.contentName = value.optionName;
                trackingData.payload = {
                    attributeCode: value.optionId !== null ? value.optionId.toString() : null,
                    attributeName: value.optionName,
                    screenName: trackingScreenName
                };
            }
            if (filterCodeValues.length) {
                routeQuery = _objectSpreadProps(_objectSpread({}, filterParams), {
                    [value.filterCode]: filterCodeValues.join(",")
                });
            } else {
                const _filterCode = value.filterCode, { [_filterCode]: tbr1  } = filterParams, restFilterParams1 = _objectWithoutProperties(filterParams, [
                    _filterCode
                ].map(_toPropertyKey));
                routeQuery = restFilterParams1;
            }
        } else {
            var ref1;
            routeQuery = _objectSpread({}, filterParams, value.filterCode ? {
                [value.filterCode]: (ref1 = value.optionId) === null || ref1 === void 0 ? void 0 : ref1.toString()
            } : {});
            trackingData.contentName = value.optionName;
            trackingData.payload = {
                attributeCode: value.filterCode,
                attributeName: value.filterName,
                screenName: trackingScreenName
            };
        }
        // if user select a filter then track
        if (trackingData.contentName) {
            targetUrl.search = new URLSearchParams(routeQuery).toString();
            trackingData.payload = {
                url: targetUrl.toString()
            };
            (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_7__/* .trackManually */ .gu)(trackingData.contentName, trackingData.regionName, trackingData.target, JSON.stringify(trackingData.payload));
        }
        modifyBehaviorBaseOnOptions(routeQuery, options);
    }, [
        newQuery
    ]);
    const onSortByPrice = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        let priceGte = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, priceLte = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, options = arguments.length > 2 ? arguments[2] : void 0;
        const finalQuery = (options === null || options === void 0 ? void 0 : options.updatedQuery) || newQuery;
        const { page , price_gte , price_lte  } = finalQuery, filterParams = _objectWithoutProperties(finalQuery, [
            "page",
            "price_gte",
            "price_lte"
        ]);
        const [validPriceGte, validPriceLte] = priceGte < priceLte ? [
            priceGte,
            priceLte
        ] : [
            priceLte,
            priceGte
        ];
        const routeQuery = _objectSpread({}, filterParams, validPriceGte && {
            price_gte: validPriceGte
        }, validPriceLte && {
            price_lte: validPriceLte
        });
        modifyBehaviorBaseOnOptions(routeQuery, options);
        (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_7__/* .trackManually */ .gu)("sortProductResult", "sortFilterProduct", "".concat(priceGte, ",").concat(priceLte), "pricerange");
    }, [
        newQuery
    ]);
    const onSortOptionSelected = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((option, options)=>{
        const [sort, order] = (0,_shared_helpers__WEBPACK_IMPORTED_MODULE_6__/* .extractSortQuery */ .To)(option.optionCode);
        const defaultSortOption = defaultSortOptionCode ? (0,_shared_helpers__WEBPACK_IMPORTED_MODULE_6__/* .getDefaultSortOptions */ .Fb)(sortByCreatedAt).find((option)=>option.optionCode === (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)(defaultSortOptionCode)) || null : null;
        const [defaultSort, defaultOrder] = defaultSortOption ? (0,_shared_helpers__WEBPACK_IMPORTED_MODULE_6__/* .extractSortQuery */ .To)(defaultSortOption.optionCode) : [
            undefined,
            undefined
        ];
        const { page  } = newQuery, filterParams = _objectWithoutProperties(newQuery, [
            "page"
        ]);
        let routeQuery;
        // case there is config default sort option name: do not allowed unselect selected option
        // case there is config default sort option name: do not show sort and order in query param
        if ((!defaultSortOptionCode && sort === query.sort && order === query.order || defaultSortOptionCode && sort === defaultSort && order === defaultOrder) && // case enable flag enableSearchAlgoABTesting === true, should go still allow
        // unselect selected option & show sort and order in query param
        !noActiveDefaultSortOption) {
            const { sort: tbr , order: tbr2  } = filterParams, restFilterParams = _objectWithoutProperties(filterParams, [
                "sort",
                "order"
            ]);
            routeQuery = restFilterParams;
        } else {
            routeQuery = _objectSpreadProps(_objectSpread({}, filterParams), {
                sort: sort,
                order: order
            });
        }
        modifyBehaviorBaseOnOptions(routeQuery, options);
    }, [
        newQuery
    ]);
    const onClickCategoriesFilterOption = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((option, categoriesFilters)=>{
        if (!option.code) return;
        const { categories  } = newQuery, restQuery = _objectWithoutProperties(newQuery, [
            "categories"
        ]);
        const activeCatsArray = categories ? typeof categories == "string" ? categories.split(",") : categories : [];
        const activeCats = new Set(activeCatsArray);
        const addActiveChildren = (root)=>{
            if (!root.children.length) return;
            root.children.forEach((child)=>{
                if (!!child.code && !!root.code && activeCats.has(root.code)) {
                    activeCats.add(child.code);
                }
                addActiveChildren(child);
            });
        };
        categoriesFilters.forEach(addActiveChildren);
        const isCheck = !activeCats.has(option.code);
        const nodeById = new Map();
        const buildMapCatById = (cats)=>{
            cats.forEach((cat)=>{
                if (typeof cat.id === "number") {
                    nodeById.set(cat.id, cat);
                }
                if (!!cat.children.length) {
                    buildMapCatById(cat.children);
                }
            });
        };
        buildMapCatById(categoriesFilters);
        // user select new category
        if (isCheck) {
            // 1. add option
            activeCats.add(option.code);
            // 3. check all ancestors
            const checkParent = (root)=>{
                if (typeof root.parentId === "number") {
                    const parent = nodeById.get(root.parentId);
                    const isAllChildrenChecked = parent === null || parent === void 0 ? void 0 : parent.children.every((child)=>!!child.code && activeCats.has(child.code));
                    if (!!(parent === null || parent === void 0 ? void 0 : parent.code) && isAllChildrenChecked) {
                        activeCats.add(parent === null || parent === void 0 ? void 0 : parent.code);
                        checkParent(parent);
                    }
                }
            };
            checkParent(option);
        } else {
            // user unselect category
            // remove all children
            const deleteUnselectChildrendCode = (root)=>{
                if (!!root.code) {
                    activeCats.delete(root.code);
                    root.children.forEach((child)=>{
                        if (!!child.code) {
                            child.children.forEach(deleteUnselectChildrendCode);
                            activeCats.delete(child.code);
                        }
                    });
                }
            };
            deleteUnselectChildrendCode(option);
            // remove all ancestors
            const checkParent1 = (root)=>{
                if (typeof root.parentId === "number") {
                    const parent = nodeById.get(root.parentId);
                    if (!!(parent === null || parent === void 0 ? void 0 : parent.code) && activeCats.has(parent === null || parent === void 0 ? void 0 : parent.code)) {
                        activeCats.delete(parent.code);
                        checkParent1(parent);
                    }
                }
            };
            checkParent1(option);
            // remove option
            activeCats.delete(option.code);
        }
        // only keep parent selected code to push to url
        const urlCats = new Set();
        const addRielCats = (root)=>{
            if (!root.code) return;
            if (activeCats.has(root.code)) {
                urlCats.add(root.code);
            }
            if (!!root.children.length && !activeCats.has(root.code)) {
                root.children.forEach(addRielCats);
            }
        };
        categoriesFilters.forEach(addRielCats);
        const modifiedQueries = !!urlCats.size ? _objectSpreadProps(_objectSpread({}, restQuery), {
            categories: [
                ...urlCats
            ].join(",")
        }) : _objectSpread({}, restQuery);
        modifyBehaviorBaseOnOptions(modifiedQueries);
    }, [
        newQuery
    ]);
    const getActiveCategories = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((categoriesFilter)=>{
        const { categories  } = newQuery;
        const activeOptionsArray = categories ? typeof categories == "string" ? categories.split(",") : categories : [];
        const activeCats = new Set(activeOptionsArray);
        const res = [];
        const addActiveCats = (root)=>{
            if (!root.code) return;
            if (activeCats.has(root.code)) {
                res.push(root);
            } else {
                root.children.forEach(addActiveCats);
            }
        };
        categoriesFilter.forEach(addActiveCats);
        return res;
    }, [
        newQuery
    ]);
    const onRemoveCategory = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((category)=>{
        const { categories  } = newQuery, rest = _objectWithoutProperties(newQuery, [
            "categories"
        ]);
        const activeOptionsArray = categories ? typeof categories == "string" ? categories.split(",") : categories : [];
        const activeCats = new Set(activeOptionsArray);
        activeCats.delete(category);
        const modifiedQueries = !!activeCats.size ? _objectSpreadProps(_objectSpread({}, rest), {
            categories: [
                ...activeCats
            ].join(",")
        }) : _objectSpread({}, rest);
        modifyBehaviorBaseOnOptions(modifiedQueries);
    }, [
        newQuery
    ]);
    return {
        clearFilterLink,
        getActiveFilterOptions,
        onClickFilterOption,
        onSortByPrice,
        onSortOptionSelected,
        getActiveCategories,
        onClickCategoriesFilterOption,
        onRemoveCategory
    };
};


/***/ }),

/***/ 774608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CY": function() { return /* binding */ getKeyFromNode; },
/* harmony export */   "Fb": function() { return /* binding */ getDefaultSortOptions; },
/* harmony export */   "I_": function() { return /* binding */ getCollectionSlug; },
/* harmony export */   "N2": function() { return /* binding */ findChildren; },
/* harmony export */   "N8": function() { return /* binding */ cookCategoryTree; },
/* harmony export */   "Ou": function() { return /* binding */ getDisplayFilter; },
/* harmony export */   "To": function() { return /* binding */ extractSortQuery; },
/* harmony export */   "j3": function() { return /* binding */ getActiveSortOption; },
/* harmony export */   "kr": function() { return /* binding */ cookFilterPrice; },
/* harmony export */   "pt": function() { return /* binding */ omitQuery; },
/* harmony export */   "qh": function() { return /* binding */ convertSubsections; },
/* harmony export */   "tF": function() { return /* binding */ getDataFromKey; },
/* harmony export */   "wi": function() { return /* binding */ findAncestors; },
/* harmony export */   "xP": function() { return /* binding */ getSignatureQueryParam; }
/* harmony export */ });
/* unused harmony exports clearFilterLink, replaceVariablesWithValues */
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19840);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(927250);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(634655);
/* harmony import */ var types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(189782);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/**
 *
 * @param  query
 * @returns
 * remove dynamic params from query
 * - ex: domain.vn/c/abc?slug=abc&page=2 -> domain.vn/c/abc?page=2
 */ const omitQuery = (query)=>{
    const omitKeys = [
        "slug",
        "categoryId",
        "sellerCategoryId",
        "brandId",
        "sellerId", 
    ];
    return (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__/* .omit */ .CE)(query, omitKeys);
};
const joinSortQuery = (param)=>{
    let { sort , order  } = param;
    return "".concat(sort).concat(SORT_QUERY_JOIN_CHAR).concat(order);
};
const SORT_QUERY_JOIN_CHAR = "&";
const getDefaultSortOptions = (sortByCreatedAt)=>{
    return [
        {
            optionName: (0,i18n__WEBPACK_IMPORTED_MODULE_1__.t)("Khuyến m\xe3i tốt nhất"),
            optionCode: joinSortQuery({
                sort: "SORT_BY_DISCOUNT_PERCENT",
                order: types__WEBPACK_IMPORTED_MODULE_2__/* .OrderBy.DESC */ .d.DESC
            })
        },
        {
            optionName: (0,i18n__WEBPACK_IMPORTED_MODULE_1__.t)("Gi\xe1 tăng dần"),
            optionCode: joinSortQuery({
                sort: "SORT_BY_PRICE",
                order: types__WEBPACK_IMPORTED_MODULE_2__/* .OrderBy.ASC */ .d.ASC
            })
        },
        {
            optionName: (0,i18n__WEBPACK_IMPORTED_MODULE_1__.t)("Gi\xe1 giảm dần"),
            optionCode: joinSortQuery({
                sort: "SORT_BY_PRICE",
                order: types__WEBPACK_IMPORTED_MODULE_2__/* .OrderBy.DESC */ .d.DESC
            })
        },
        {
            optionName: (0,i18n__WEBPACK_IMPORTED_MODULE_1__.t)("Sản phẩm mới nhất"),
            optionCode: joinSortQuery({
                sort: !!sortByCreatedAt ? "SORT_BY_CREATED_AT" : "SORT_BY_PUBLISH_AT",
                order: types__WEBPACK_IMPORTED_MODULE_2__/* .OrderBy.DESC */ .d.DESC
            })
        },
        {
            optionName: (0,i18n__WEBPACK_IMPORTED_MODULE_1__.t)("Sản phẩm b\xe1n chạy nhất"),
            optionCode: joinSortQuery({
                sort: "SORT_BY_TOP_SALE_QUANTITY_7_DAYS",
                order: types__WEBPACK_IMPORTED_MODULE_2__/* .OrderBy.DESC */ .d.DESC
            })
        }, 
    ];
};
const extractSortQuery = (joinedQuery)=>{
    return joinedQuery.split(SORT_QUERY_JOIN_CHAR);
};
const getActiveSortOption = (query, sortByCreatedAt, defaultSortOptionCode)=>{
    const defaultSortOption = defaultSortOptionCode ? getDefaultSortOptions(sortByCreatedAt).find((option)=>option.optionCode === (0,i18n__WEBPACK_IMPORTED_MODULE_1__.t)(defaultSortOptionCode)) || null : null;
    const sortOptionFromQuery = getDefaultSortOptions(sortByCreatedAt).find((opt)=>opt.optionCode === joinSortQuery({
            sort: query.sort,
            order: query.order
        }));
    return sortOptionFromQuery !== null && sortOptionFromQuery !== void 0 ? sortOptionFromQuery : defaultSortOption;
};
const clearFilterLink = (rootPath, query)=>{
    return rootPath === "/search" ? "/search?router=productListing".concat(query.query ? "&query=".concat(query.query) : "") : "".concat( true ? window.location.origin : 0).concat(rootPath);
};
const cookFilterPrice = function() {
    let lte = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10000000, gte = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    /**
   * default : gte: 0, lte: 10.000.000, step = 500.000, delta = lte - gte
   * lte: is rounded to 50k, 500K, 1M, 5M
   * step = (delta / 20) is rounded to 5k, 10k, 100K, 500K
   */ lte = lte === null || isNaN(lte) ? 10000000 : lte;
    gte = gte === null || isNaN(gte) ? 0 : gte;
    let priceLte = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .stringToInteger */ .C)(lte.toString()) || (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .stringToInteger */ .C)(gte.toString(), 0) + 500000;
    const priceGte = 0;
    if (priceLte < 200000) {
        priceLte = Math.ceil(priceLte / 50000) * 50000;
    }
    if (priceLte > 200000 && priceLte < 500000) {
        priceLte = 500000;
    }
    if (priceLte > 500000 && priceLte < 5000000) {
        priceLte = Math.ceil(priceLte / 1000000) * 1000000;
    }
    if (priceLte > 5000000) {
        priceLte = Math.ceil(priceLte / 5000000) * 5000000;
    }
    const delta = priceLte - priceGte;
    let step = 100000;
    if (delta < 200000) {
        step = Math.ceil(delta / 100000) * 5000;
    /**minStep : 5.000d , maxStep: 10.000 */ }
    if (delta > 200000 && delta <= 2000000) {
        step = Math.ceil(delta / 200000) * 10000;
    /**minStep : 20.000d , maxStep: 100.000 */ }
    if (delta > 2000000 && delta <= 10000000) {
        step = Math.ceil(delta / 2000000) * 100000;
    /**minStep : 100.000d , maxStep: 500.000 */ }
    if (delta > 10000000) {
        step = 500000;
    }
    // steps
    return {
        max: priceLte,
        min: priceGte,
        step: step
    };
};
const getDisplayFilter = (filters)=>{
    return filters.filter((filter)=>{
        var ref;
        return (filter === null || filter === void 0 ? void 0 : (ref = filter.options) === null || ref === void 0 ? void 0 : ref.length) && filter.options.length > 1;
    });
};
const getCollectionSlug = (slug)=>slug ? "/c/".concat(slug) : "";
const getSignatureQueryParam = (query)=>{
    let signatureFilterQueryParams = {};
    const { brandId , sellerId , providerId , sellerCategories , masterCategoryIds , categoryId , sellerCategoryId ,  } = query;
    // handle link like this: /search?router=productListing&sellerCategories=015
    if (sellerCategories) {
        signatureFilterQueryParams = {
            masterCategoryIds: sellerCategories
        };
    } else if (masterCategoryIds) {
        signatureFilterQueryParams = {
            masterCategoryIds: masterCategoryIds
        };
    } else if (providerId) {
        signatureFilterQueryParams = {
            providerIds: [
                providerId
            ]
        };
    } else if (sellerId) {
        signatureFilterQueryParams = {
            sellerIds: [
                sellerId
            ]
        };
    } else if (brandId) {
        signatureFilterQueryParams = {
            brands: typeof brandId === "string" ? [
                brandId
            ] : [
                ...brandId
            ]
        };
    } else if (categoryId) {
        signatureFilterQueryParams = {
            masterCategoryIds: [
                categoryId
            ]
        };
    } else if (sellerCategoryId) {
        signatureFilterQueryParams = {
            categories: [
                sellerCategoryId
            ]
        };
    }
    return signatureFilterQueryParams;
};
/**
 *
 * @param i a number
 * @returns return '01' if i = 1, return '11' if i = 11
 */ const padString = (i)=>i < 10 ? "0" + i : "" + i;
const CURRENT_MONTH_KEY = "%currentMonth%";
const CURRENT_YEAR_KEY = "%currentYear%";
const replaceVariablesWithValues = (date, metaTitle)=>{
    const mapMetaTitleVariables = {
        [CURRENT_MONTH_KEY]: padString(date.getMonth() + 1),
        [CURRENT_YEAR_KEY]: padString(date.getFullYear())
    };
    if (metaTitle) {
        const reg = new RegExp(Object.keys(mapMetaTitleVariables).join("|"), "g");
        return metaTitle.replace(reg, (matched)=>mapMetaTitleVariables[matched]);
    }
    return metaTitle;
};
const cookCategoryTree = (rawCategories)=>{
    if (!(rawCategories === null || rawCategories === void 0 ? void 0 : rawCategories.length)) return {
        cookedCategories: {},
        cookedCategoriesById: new Map(),
        cookedCategoriesByCode: new Map()
    };
    const nodeMap = new Map();
    for (const c of rawCategories){
        nodeMap.set(c.id, _objectSpreadProps(_objectSpread({}, c), {
            children: {}
        }));
    }
    const result = {};
    const nodeById = new Map();
    const nodeByCode = new Map();
    for (const node of nodeMap.values()){
        var _parentId;
        const parentId = (_parentId = node.parentId) !== null && _parentId !== void 0 ? _parentId : 0;
        const parent = parentId ? nodeMap.get(parentId) : undefined;
        if (!parent) {
            result[node.id] = node;
        } else {
            parent.children[node.id] = node;
        }
        nodeById.set(node.id, node);
        nodeByCode.set(node.code, node);
    }
    return {
        cookedCategories: result,
        cookedCategoriesById: nodeById,
        cookedCategoriesByCode: nodeByCode
    };
};
const getKeyFromNode = (node)=>{
    var _parentId;
    return "".concat(node.id, "_").concat((_parentId = node.parentId) !== null && _parentId !== void 0 ? _parentId : 0);
};
const getDataFromKey = (key)=>{
    const [id, parentId] = key.split("_");
    return {
        id: Number(id),
        parentId: Number(parentId)
    };
};
const findChildren = function(node) {
    let skipInitial = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const keys = [];
    !skipInitial && (node === null || node === void 0 ? void 0 : node.id) && keys.push(getKeyFromNode(node));
    var _children;
    for (const child of Object.values((_children = node.children) !== null && _children !== void 0 ? _children : {})){
        keys.push(...findChildren(child));
    }
    return keys;
};
const findAncestors = function(node, cookedCategoriesById) {
    let skipInitial = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    const ancestorsKeys = [];
    !skipInitial && (node === null || node === void 0 ? void 0 : node.id) && ancestorsKeys.push(getKeyFromNode(node));
    let parentId = node === null || node === void 0 ? void 0 : node.parentId;
    while(parentId){
        const parent = cookedCategoriesById.get(parentId);
        if (!parent) break;
        ancestorsKeys.push(getKeyFromNode(parent));
        parentId = parent.parentId;
    }
    return ancestorsKeys;
};
const convertSubsections = (subsectionsFromWorkload)=>{
    const { brands , others  } = subsectionsFromWorkload;
    const res = [];
    if (!!brands && !!brands.length) {
        res.push({
            type: "IMAGES",
            items: brands.map((brand)=>({
                    linkUrl: brand.url,
                    thumbnailUrl: brand.logo
                }))
        });
    }
    others === null || others === void 0 ? void 0 : others.forEach((other)=>{
        if (!!(other === null || other === void 0 ? void 0 : other.items.length)) {
            res.push({
                type: "IMAGES_AND_TEXT",
                title: other.label,
                items: other.items.map((item)=>({
                        linkUrl: item.url,
                        thumbnailUrl: item.image,
                        description: item.description
                    }))
            });
        }
    });
    return res;
};


/***/ }),

/***/ 207971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ ShowMoreButton; }
/* harmony export */ });
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(806748);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  min-width: 250px;\n  padding: 0.625rem 0.5rem;\n  background-color: #fff;\n  text-align: center;\n\n  :active,\n  :hover,\n  :focus {\n    text-decoration: none;\n  }\n\n  :active {\n    color: ",
        ";\n  }\n\n  > div {\n    display: unset;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

const ShowMoreButton = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .z)(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.link500;
});


/***/ }),

/***/ 189782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ OrderBy; },
/* harmony export */   "t": function() { return /* binding */ DateFormat; }
/* harmony export */ });
var OrderBy;
(function(OrderBy) {
    OrderBy["ASC"] = "ASC";
    OrderBy["DESC"] = "DESC";
})(OrderBy || (OrderBy = {}));
var DateFormat;
(function(DateFormat) {
    DateFormat["YMD"] = "yyyy-MM-dd";
})(DateFormat || (DateFormat = {}));


/***/ })

}]);